// Even product cards. Added Oct 20, 2026 (Sydney).
// Card titles run from one to three lines, so on phones the price, stars and
// swatches of side by side cards sat at different heights. This sets the title
// block, then the text block under the image, to the tallest card in each row.
(function () {
  var pending = false;

  var lastSig = "", nudgeT; function byRow(items) {
    var rows = {};
    items.forEach(function (item) {
      if (!item.offsetWidth) return;
      var key = Math.round(item.getBoundingClientRect().top + window.scrollY);
      (rows[key] = rows[key] || []).push(item);
    });
    return Object.keys(rows).map(function (key) { return rows[key]; });
  }

  function level(rows, selector) {
    rows.forEach(function (row) {
      var parts = row.map(function (item) { return item.querySelector(selector); });
      var tallest = 0;
      parts.forEach(function (part) {
        if (part) tallest = Math.max(tallest, part.offsetHeight);
      });
      if (row.length < 2) return;
      parts.forEach(function (part) {
        if (part) part.style.minHeight = tallest + "px";
      });
    });
  }

  function evenCards() {
    pending = false;
    var items = Array.prototype.slice.call(document.querySelectorAll("product-grid-item"));
    if (!items.length) return;

    items.forEach(function (item) {
      var title = item.querySelector(".product__grid__title__group");
      var text = item.querySelector(".product__grid__link--stacked");
      if (title) title.style.minHeight = "";
      if (text) text.style.minHeight = "";
    });

    var rows = byRow(items);
    level(rows, ".product__grid__title__group");
    level(rows, ".product__grid__link--stacked"); var sig = items.map(function (it) { return it.offsetHeight; }).join(","); if (sig !== lastSig) { lastSig = sig; clearTimeout(nudgeT); nudgeT = setTimeout(function () { window.dispatchEvent(new Event("resize")); }, 80); }
  }

  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(evenCards);
  }

  document.addEventListener("DOMContentLoaded", queue);
  window.addEventListener("load", queue);
  window.addEventListener("resize", queue);
  document.addEventListener("shopify:section:load", queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);

  // Collection filters, quick add and the review stars all load after the page,
  // so level the rows again whenever cards or their contents change.
  new MutationObserver(function (changes) {
    for (var i = 0; i < changes.length; i++) {
      var target = changes[i].target;
      if (target.closest && target.closest("product-grid-item, .js-grid, [data-grid]")) {
        queue();
        return;
      }
      var added = changes[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].querySelector && (added[j].matches("product-grid-item") || added[j].querySelector("product-grid-item"))) {
          queue();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  queue();
})();

// Off site links open in a new tab. Added Oct 20, 2026 (Sydney).
// The shop stays open in its own tab, scrolled to the same spot, so when the
// shopper closes the other site (or taps Back on a phone) they land right
// where they left off instead of on a fresh page.
// Checkout, Shop Pay and customer accounts stay in the same tab.
(function () {
  var ownSites = /(^|\.)(restandreset\.com|myshopify\.com|shopify\.com|shop\.app)$/i;

  function isOffSite(link) {
    if (link.protocol !== "http:" && link.protocol !== "https:") return false;
    if (link.hasAttribute("download")) return false;
    if (link.hostname === window.location.hostname) return false;
    return !ownSites.test(link.hostname);
  }

  function openInNewTab(link) {
    if (!isOffSite(link)) return;
    link.target = "_blank";
    var rel = (link.getAttribute("rel") || "").split(/\s+/).filter(Boolean);
    if (rel.indexOf("noopener") === -1) rel.push("noopener");
    link.setAttribute("rel", rel.join(" "));
  }

  function markAll() {
    document.querySelectorAll("a[href]").forEach(openInNewTab);
  }

  // Catch links added later by apps (reviews, cart, chat) at the moment they are tapped.
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a[href]");
    if (link && link instanceof HTMLAnchorElement) openInNewTab(link);
  }, true);

  document.addEventListener("DOMContentLoaded", markAll);
  document.addEventListener("shopify:section:load", markAll);
})();

// Free add-ons read "Free". Added Oct 26, 2026 (Sydney).
// The product add-on app labels each add-on "Name (+ price)", so free embroidery
// read "Embroidery (+ $0)", which looks like a mistake next to "free embroidery".
// When an add-on's price is zero the label reads "Embroidery (Free)" instead.
// Paid add-ons are untouched, and if the app changes a price the label follows.
(function () {
  function isZero(text) {
    return /^[^0-9]*0+([.,]0+)?[^0-9]*$/.test(String(text).trim());
  }

  function fix(price) {
    var before = price.previousSibling;
    var free = price.__rrFree;
    if (isZero(price.textContent)) {
      if (free) return;
      if (before && before.nodeType === 3) before.nodeValue = before.nodeValue.replace(/\(\+\s*$/, "(");
      free = document.createElement("span");
      free.className = "rr-addon-free";
      free.textContent = "Free";
      price.parentNode.insertBefore(free, price);
      price.style.display = "none";
      price.__rrFree = free;
    } else if (free) {
      if (free.parentNode) free.parentNode.removeChild(free);
      before = price.previousSibling;
      if (before && before.nodeType === 3) before.nodeValue = before.nodeValue.replace(/\($/, "(+ ");
      price.style.display = "";
      price.__rrFree = null;
    }
  }

  function fixAll() {
    document.querySelectorAll('mf-addon-price[mode="addon"]').forEach(fix);
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; fixAll(); });
  }

  document.addEventListener("DOMContentLoaded", queue);
  window.addEventListener("load", queue);
  new MutationObserver(function (changes) {
    for (var i = 0; i < changes.length; i++) {
      var node = changes[i].target;
      var el = node.nodeType === 3 ? node.parentNode : node;
      if (el && el.closest && el.closest("mf-addon-price, mf-addon-toggle, .mf-addon__toggle")) { queue(); return; }
      var added = changes[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].querySelector && (added[j].matches("mf-addon-price") || added[j].querySelector("mf-addon-price"))) { queue(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  queue();
})();

// Embroidery preview. Added Oct 26, 2026 (Sydney, from the team meeting).
// On every product with the embroidery add-on, a panel under the Text box shows
// the shopper's initials or name in the font and thread color they picked, and an
// example (ASR) until they type. The font is read from the app's own font
// samples. The thread colors are ours: the app's swatches are repainted in the
// exact thread colors from the Embroidery Guide, and the preview letters use the
// same values, so the swatch, the preview and the guide all match. Under the
// letters it names the font and color (Script in Dark Blue). The panel is a light
// ivory; white thread alone switches it to charcoal so the letters stay visible.
(function () {
  var EXAMPLE = "ASR";
  // Same values as the thread squares in sections/rr-embroidery-guide.liquid.
  var THREAD = {
    "black": "#1F1D1A", "white": "#FFFFFF", "gray": "#9B9893", "beige": "#D9C8A9",
    "brown": "#6E4D35", "dark blue": "#2D3B57", "light blue": "#A9BED3",
    "green": "#6F8669", "pink": "#E6B8BF",
    "coast": "#98A0A5", "flax": "#DED5C6", "sage": "#BCC4BF", "slate": "#6B7A8B"
  };

  function css() {
    if (document.getElementById("rr-emb-preview-css")) return;
    var s = document.createElement("style");
    s.id = "rr-emb-preview-css";
    s.textContent =
      ".rr-emb-preview{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;min-height:120px;margin:12px 0 4px;padding:16px;border:1px solid #E6E0D6;border-radius:0;background:#FDFBF7;text-align:center;}" +
      ".rr-emb-preview.is-light{background:#4A453C;border-color:#4A453C;}" +
      ".rr-emb-preview__label{font:500 10px/1 var(--FONT-STACK-BODY,'Work Sans',sans-serif);letter-spacing:.16em;text-transform:uppercase;color:#657060;}" +
      ".rr-emb-preview.is-light .rr-emb-preview__label{color:#E6E0D6;}" +
      ".rr-emb-preview__text{max-width:100%;font-size:36px;line-height:1.15;overflow-wrap:anywhere;}" +
      ".rr-emb-preview__text.is-example{opacity:.55;}" +
      ".rr-emb-preview__meta{font:400 12px/1.3 var(--FONT-STACK-BODY,'Work Sans',sans-serif);color:#657060;}" +
      ".rr-emb-preview.is-light .rr-emb-preview__meta{color:#E6E0D6;}";
    document.head.appendChild(s);
  }

  // The font choices are the group with Classic or Script in it; the first other
  // group of choices is the thread color.
  function groups(addon) {
    var by = {};
    addon.querySelectorAll('input[type="radio"]').forEach(function (r) { (by[r.name] = by[r.name] || []).push(r); });
    var font = null, color = null;
    Object.keys(by).forEach(function (n) {
      var vals = by[n].map(function (r) { return r.value.toLowerCase(); });
      if (vals.indexOf("script") > -1 || vals.indexOf("classic") > -1) font = by[n];
      else if (!color) color = by[n];
    });
    return { font: font, color: color };
  }

  function fontOf(radio) {
    var lab = radio.closest("label") || radio.parentNode;
    var aa = Array.prototype.find.call(lab.querySelectorAll("*"), function (e) { return !e.children.length && /Aa/.test(e.textContent); });
    return aa ? getComputedStyle(aa).fontFamily : "";
  }

  function swatchOf(radio) {
    var lab = radio.closest("label") || radio.parentNode;
    if (lab.__rrSwatch) return lab.__rrSwatch;
    var sw = Array.prototype.find.call(lab.querySelectorAll("*"), function (e) {
      return e !== radio && getComputedStyle(e).backgroundColor !== "rgba(0, 0, 0, 0)";
    });
    if (sw) lab.__rrSwatch = sw;
    return sw;
  }

  function colorOf(radio) {
    var ours = THREAD[radio.value.trim().toLowerCase()];
    if (ours) return ours;
    var sw = swatchOf(radio);
    return sw ? getComputedStyle(sw).backgroundColor : "";
  }

  // Paint the app's swatches in our thread colors.
  function paint(g) {
    if (!g.color) return;
    g.color.forEach(function (r) {
      var ours = THREAD[r.value.trim().toLowerCase()], sw = swatchOf(r);
      if (ours && sw && sw.style.backgroundColor !== ours) sw.style.setProperty("background-color", ours, "important");
    });
  }

  function hexLight(col) {
    var m = String(col).match(/^#([0-9a-f]{6})$/i);
    if (!m) return light(col);
    var n = parseInt(m[1], 16);
    return light("rgb(" + (n >> 16) + "," + ((n >> 8) & 255) + "," + (n & 255) + ")");
  }

  function light(rgb) {
    var m = String(rgb).match(/\d+/g);
    if (!m) return false;
    return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) > 200;
  }

  function draw(addon) {
    var box = addon.__rrPreview, text = addon.querySelector('input[type="text"], textarea');
    if (!box || !text) return;
    var g = groups(addon);
    if (!g.font) return;
    paint(g);
    var f = g.font.filter(function (r) { return r.checked; })[0] || g.font[0];
    var c = g.color ? g.color.filter(function (r) { return r.checked; })[0] : null;
    var col = (c && colorOf(c)) || "#4A453C";
    var typed = text.value.trim();
    var out = box.querySelector(".rr-emb-preview__text");
    var meta = box.querySelector(".rr-emb-preview__meta");
    out.textContent = typed || EXAMPLE;
    out.classList.toggle("is-example", !typed);
    out.style.fontFamily = fontOf(f);
    out.style.color = col;
    meta.textContent = f.value + (c ? " in " + c.value : "");
    box.classList.toggle("is-light", hexLight(col));
  }

  function setup(addon) {
    var text = addon.querySelector('input[type="text"], textarea');
    if (!text || !groups(addon).font) return;
    if (addon.__rrPreview && addon.contains(addon.__rrPreview)) { draw(addon); return; }
    css();
    var box = document.createElement("div");
    box.className = "rr-emb-preview";
    box.setAttribute("aria-live", "polite");
    box.innerHTML = '<span class="rr-emb-preview__label">Your embroidery</span><span class="rr-emb-preview__text"></span><span class="rr-emb-preview__meta"></span>';
    var anchor = text;
    while (anchor.parentNode && anchor.parentNode !== addon && !anchor.parentNode.querySelector('input[type="radio"]')) anchor = anchor.parentNode;
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    addon.__rrPreview = box;
    if (!addon.__rrListen) {
      addon.__rrListen = true;
      addon.addEventListener("input", function () { draw(addon); });
      addon.addEventListener("change", function () { draw(addon); });
    }
    draw(addon);
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      document.querySelectorAll("mf-product-addon").forEach(setup);
    });
  }

  document.addEventListener("DOMContentLoaded", queue);
  window.addEventListener("load", queue);
  // The app draws its options after the page loads and again when the box is
  // ticked, so set the preview up whenever the add-on changes. Changes inside the
  // preview itself are ignored so drawing it never loops back here.
  new MutationObserver(function (changes) {
    for (var i = 0; i < changes.length; i++) {
      var el = changes[i].target;
      if (el.nodeType === 3) el = el.parentNode;
      if (el && el.closest && el.closest("mf-product-addon") && !el.closest(".rr-emb-preview")) { queue(); return; }
      var added = changes[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].querySelector && (added[j].matches("mf-product-addon") || added[j].querySelector("mf-product-addon"))) { queue(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  queue();
})();

// Cart trust lines and color names. Added Oct 26, 2026 (Sydney).
// Under the Checkout and Shop Pay buttons in the Rebuy cart: the delivery time,
// where discount codes go (the 20% welcome code is entered at checkout), and the
// three promises the site already makes. Also shows color names the way the rest
// of the site does: products whose color option reads "in White" or "with Stitch in
// Coast" show "White" and "Stitch in Coast" in the cart. Product data is unchanged.
// Rebuy redraws the cart on every change, so this runs again after each redraw.
// Product photos in the cart are centered on the product itself, not the photo:
// several product shots have the piece sitting left or high in the frame, which the
// cart's zoom made obvious. Each photo is measured once (where the pixels stop being
// plain background), then shifted and sized so the piece sits dead center at about
// 80% of the square, the same on every line. Lifestyle photos that fill the frame,
// and any photo that cannot be read, are left as they are.
(function () {
  var FILL = 0.8;
  var measured = {};

  function measure(src, done) {
    if (measured[src]) { done(measured[src]); return; }
    var p = new Image();
    p.crossOrigin = "anonymous";
    p.onload = function () {
      var r = null;
      try {
        if (Math.abs(p.naturalWidth - p.naturalHeight) > 2) throw 0;
        var N = 64, c = document.createElement("canvas");
        c.width = N; c.height = N;
        var x = c.getContext("2d");
        x.drawImage(p, 0, 0, N, N);
        var d = x.getImageData(0, 0, N, N).data;
        var px = function (i, k) { var o = (k * N + i) * 4; return [d[o], d[o + 1], d[o + 2]]; };
        var cs = [px(1, 1), px(N - 2, 1), px(1, N - 2), px(N - 2, N - 2)];
        var bg = [0, 1, 2].map(function (n) { return cs.reduce(function (s, q) { return s + q[n]; }, 0) / 4; });
        var spread = cs.reduce(function (s, q) { return s + Math.abs(q[0] - bg[0]) + Math.abs(q[1] - bg[1]) + Math.abs(q[2] - bg[2]); }, 0);
        if (spread > 60) throw 0;
        var minx = N, miny = N, maxx = -1, maxy = -1;
        for (var k = 0; k < N; k++) for (var i = 0; i < N; i++) {
          var q = px(i, k);
          if (Math.abs(q[0] - bg[0]) + Math.abs(q[1] - bg[1]) + Math.abs(q[2] - bg[2]) > 24) {
            if (i < minx) minx = i; if (i > maxx) maxx = i; if (k < miny) miny = k; if (k > maxy) maxy = k;
          }
        }
        if (maxx < 0) throw 0;
        var w = (maxx - minx + 1) / N, h = (maxy - miny + 1) / N;
        if (w > 0.95 && h > 0.95) throw 0;
        r = { cx: (minx + maxx + 1) / 2 / N, cy: (miny + maxy + 1) / 2 / N, size: Math.max(w, h),
              bg: "rgb(" + bg.map(Math.round).join(",") + ")" };
      } catch (e) { r = { skip: true }; }
      measured[src] = r;
      done(r);
    };
    p.onerror = function () { measured[src] = { skip: true }; done(measured[src]); };
    p.src = src + (src.indexOf("?") > -1 ? "&" : "?") + "rrc=1";
  }

  function center(img) {
    var src = img.currentSrc || img.src;
    if (!src || img.__rrCentered === src) return;
    img.__rrCentered = src;
    measure(src, function (r) {
      if (!r || r.skip) return;
      var s = Math.max(1, Math.min(2.2, FILL / r.size));
      var tx = (0.5 - r.cx) * s * 100, ty = (0.5 - r.cy) * s * 100;
      img.style.setProperty("transform", "translate(" + tx.toFixed(2) + "%, " + ty.toFixed(2) + "%) scale(" + s.toFixed(3) + ")", "important");
      img.style.setProperty("transform-origin", "50% 50%", "important");
      img.style.setProperty("object-fit", "cover", "important");
      img.style.setProperty("object-position", "50% 50%", "important");
      img.style.setProperty("background", r.bg, "important");
      if (img.parentElement) img.parentElement.style.setProperty("background", r.bg, "important");
      var media = img.closest(".rebuy-cart__flyout-item-media");
      if (media) media.style.setProperty("background", r.bg, "important");
    });
  }

  // Delivery time matches checkout and the announcement bar: 2 to 3 business days
  // (was 3 to 5 until Oct 26, 2026, Sydney's call).
  var NOTE = "Arrives in 2 to 3 business days. Discount codes are applied at checkout.";
  var PROMISES = ["Secure checkout", "Free U.S. shipping over $199", "Easy returns"];

  function trust(flyout) {
    var buttons = flyout.querySelectorAll(".rebuy-cart__checkout-button, .rebuy-cart__shop-pay-button");
    if (!buttons.length) return;
    var last = buttons[buttons.length - 1];
    var next = last.nextElementSibling;
    if (next && next.classList.contains("rr-cart-trust")) return;
    flyout.querySelectorAll(".rr-cart-trust").forEach(function (old) { old.parentNode.removeChild(old); });
    var box = document.createElement("div");
    box.className = "rr-cart-trust";
    var p = document.createElement("p");
    p.textContent = NOTE;
    var ul = document.createElement("ul");
    PROMISES.forEach(function (t) { var li = document.createElement("li"); li.textContent = t; ul.appendChild(li); });
    box.appendChild(p);
    box.appendChild(ul);
    last.parentNode.insertBefore(box, last.nextSibling);
  }

  function colors(flyout) {
    flyout.querySelectorAll(".rebuy-cart__flyout-item-variant-title").forEach(function (v) {
      var t = v.textContent.trim();
      var n = t.replace(/^in\s+/i, "").replace(/^with\s+/i, "");
      if (n !== t && n) v.textContent = n.charAt(0).toUpperCase() + n.slice(1);
    });
  }

  var pending = false;
  function run() {
    pending = false;
    document.querySelectorAll(".rebuy-cart__flyout").forEach(function (f) {
      trust(f);
      colors(f);
      f.querySelectorAll(".rebuy-cart__flyout-item-media img, .rebuy-widget img").forEach(function (img) {
        if (img.complete) center(img); else img.addEventListener("load", function () { center(img); }, { once: true });
      });
    });
  }
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(run);
  }

  new MutationObserver(function (changes) {
    for (var i = 0; i < changes.length; i++) {
      var el = changes[i].target;
      if (el.nodeType === 3) el = el.parentNode;
      if (el && el.closest && el.closest(".rebuy-cart__flyout") && !el.closest(".rr-cart-trust")) { queue(); return; }
      var added = changes[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        if (added[k].querySelector && (added[k].matches(".rebuy-cart__flyout, .rebuy-cart") || added[k].querySelector(".rebuy-cart__flyout"))) { queue(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener("DOMContentLoaded", queue);
  queue();
})();

// Filter color names. Added Oct 26, 2026 (Sydney).
// The color filter on collection pages (desktop bar and phone filter panel) listed
// the color option exactly as it is stored on the product: "In White", "with Stitch in
// Coast". Here it reads "White", "Coast", the way the product cards and cart show it.
// Only the words on screen change; the filter links and product data are untouched.
// The filters redraw when a filter is picked, so this runs again after each redraw.
(function () {
  // Only a capitalized color name after the prefix, so "In stock" is left alone.
  var PREFIX = /^(\s*)([Ww]ith [Ss]titch [Ii]n|[Ii]n)\s+([A-Z])/;

  function tidy(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (PREFIX.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(PREFIX, function (m, space, words, first) {
          return space + first;
        });
      }
    }
  }

  function run() {
    document.querySelectorAll(".collection__desktop-toolbar, .collection-filter-modal__panel").forEach(tidy);
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }

  document.addEventListener("DOMContentLoaded", queue);
  new MutationObserver(function (changes) {
    for (var i = 0; i < changes.length; i++) {
      var el = changes[i].target;
      if (el.nodeType === 3) el = el.parentNode;
      if (el && el.closest && el.closest(".collection__desktop-toolbar, .collection-filter-modal__panel, .shopify-section")) { queue(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  queue();
})();

// Build your bed: Serene in Coast gets its own photo. Added Oct 26, 2026 (Sydney).
// The real made-bed photo the section crops for Serene is the Slate duvet set, so
// picking Coast showed a Slate stitch. This points Coast at the same photo with the
// stitch in Coast (rr-build-your-bed-serene-coast-v2.png, same framing, so the dots
// still sit on the shams, pillowcases and duvet). Flax, Sage and Slate have their own
// files already. The section reads this when it draws the photo, after it loads.
(function () {
  var COAST = "https://cdn.shopify.com/s/files/1/0630/4088/0688/files/rr-build-your-bed-serene-coast-v2.png?width=1800";
  function set() {
    document.querySelectorAll(".rr-bb[data-img-serene]").forEach(function (el) {
      if (!el.dataset.imgSereneCoast) el.dataset.imgSereneCoast = COAST;
    });
  }
  set();
  document.addEventListener("DOMContentLoaded", set);
  document.addEventListener("shopify:section:load", set);
})();

// Account icon says Account. Added Oct 29, 2026 (Sydney, Terry's ask).
// The person icon in the header had no label, so hovering it showed nothing and
// Terry was not sure what it opened. Every icon only link to the account pages now
// carries a title (the hover tip on desktop) and a label for screen readers. Links
// that already have visible text are left alone.
(function () {
  function label() {
    document.querySelectorAll('a[href*="/account"]').forEach(function (a) {
      if (a.textContent.replace(/\s+/g, "")) return;
      if (!a.getAttribute("title")) a.setAttribute("title", "Account");
      if (!a.getAttribute("aria-label")) a.setAttribute("aria-label", "Account");
    });
  }
  label();
  document.addEventListener("DOMContentLoaded", label);
  document.addEventListener("shopify:section:load", label);
})();
